import type { CreateAxiosDefaults } from "axios";

import axios from "axios";

const API_TIMEOUT = 30000;

export type CreateInstanceParameters = CreateAxiosDefaults;

export function createInstance(config: CreateInstanceParameters) {
  const instance = axios.create({
    timeout: API_TIMEOUT,
    // CORS-friendly defaults
    withCredentials: false, // Set to true only if the API requires cookies
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    ...config,
  });

  // Add request interceptor to handle CORS preflight
  instance.interceptors.request.use(
    (config) => {
      // Ensure proper content-type for JSON requests
      if (
        config.data &&
        typeof config.data === "object" &&
        !(config.data instanceof FormData)
      ) {
        config.headers["Content-Type"] = "application/json";
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    },
  );

  return instance;
}
